import React, { useMemo, useState } from "react";
import NewCard from "./NewCard";
import CardOnFile from "./CardOnFile";
import { Tabs } from "../../../../../../shared/Tabs/Tabs";
import { Modal } from "../../../../../../shared/Modal/Modal";

const ChangeCardModalClearent = ({
  showLoader,
  onSubmit,
  cardsList,
  onClose,
  publicKey,
  clientData,
}) => {
  const [selectedTab, setSelectedTab] = useState("newCard");

  const cardsOptions = useMemo(
    () =>
      cardsList.map((card) => ({
        label: card.card_number,
        value: card.card_on_file,
      })),
    [cardsList],
  );

  return (
    <Modal
      isOpen
      onClose={onClose}
      header={<Modal.Title>Change Card</Modal.Title>}
    >
      <Tabs
        className="m-b-20"
        variant="tiled"
        active={selectedTab}
        options={[
          {
            label: "New Card",
            value: "newCard",
            onClick: () => setSelectedTab("newCard"),
          },
          {
            label: "Card on File",
            value: "cardOnFile",
            onClick: () => setSelectedTab("cardOnFile"),
          },
        ]}
      />
      {selectedTab === "newCard" && (
        <NewCard
          onSubmit={onSubmit}
          showLoader={showLoader}
          publicKey={publicKey}
          clientData={clientData}
        />
      )}
      {selectedTab === "cardOnFile" && (
        <CardOnFile
          cardsOptions={cardsOptions}
          showLoader={showLoader}
          onSubmit={onSubmit}
        />
      )}
    </Modal>
  );
};

export default ChangeCardModalClearent;
